import React from 'react'
import '../scss/Resultado.css'
import IconFavorite from '../icons/IconFavorite'
import IconFavoriteBorder from '../icons/IconFavoriteBorder'

const ResultadoDetailHeader = (props) => {
  const resultado = props.resultado

  let iniciales = '--'
  if (resultado && resultado.nombre) {
    iniciales = resultado.nombre[0]
    if (resultado.apellidos) {
      iniciales += resultado.apellidos[0]
    }
  }
  iniciales = iniciales.toLocaleUpperCase()

  return <div className={'resultado ' + (props.esFavorito ? 'resultado--favorito' : '')} >
    <div className={'resultado__header'}>
      {resultado.login ? (
        <div className={'resultado__avatar'}
          style={{ backgroundImage: `url('https://ccnorte.com/a/100/${resultado.login}')` }}
        />
      ) : (
        <div className={'resultado__avatar'}>
          {iniciales}
        </div>
        // background-image: url('https://championchipnorte.com/a/80/45907140Z');

      )}

      <div className={'resultado__dorsal'}>
        Dorsal: <b>{resultado.dorsal}</b>
      </div>

      <div className={'resultado__nombre'}>
        <div className={'resultado__nombre-line'}>{resultado.nombre} {resultado.apellidos}</div>
        <div className={'resultado__info'}>
          {resultado.club && (
            <div className={'resultado__info__club'}>{resultado.club.toLowerCase()}</div>
          )}
          {resultado.localidad && (
            <div className={'resultado__info__localidad'}>{resultado.localidad.toLowerCase()}</div>
          )}
          {resultado.puesto ? (
            <div className={'resultado__puestos'}>
              <span className={'resultado__puestos__puesto'}>POS: <b>{resultado.puesto}</b> | </span>
              {resultado.puesto_sexo && (
                <span className={'resultado__puestos__puesto'}>{resultado.sexo === 'F' ? ('FEM') : ('MASC')}: <b>{resultado.puesto_sexo}</b> | </span>
              )}
              {resultado.puesto_categoria && (
                <span className={'resultado__puestos__puesto'}>{resultado.categoria_codigo ? resultado.categoria_codigo : resultado.categoria}: <b>{resultado.puesto_categoria}</b> | </span>
              )}
            </div>
          ) : (
            <div className={'resultado__puestos'}>
              {resultado.categoria_codigo}
            </div>
          )}
        </div>
      </div>

      {props.esFavorito ? (
        <button
          className={'resultado__seguir'}
          onClick={props.onClickFavorito}>
          <IconFavorite fill='white' /> Siguiendo
        </button>
      ) : (
        <button
          className={'resultado__seguir'}
          onClick={props.onClickFavorito} >
          <IconFavoriteBorder fill='white' /> Seguir
        </button>
      )}
      { /* props.esNotificar ? (
        <button className={'resultado__notificar'}
          onClick={props.onClickNotificar} >
          <IconNotificarOn />
          Notificarme
        </button>
      ) : (
        <button className={'resultado__notificar'}
          onClick={props.onClickNotificar} >
          <IconNotificarOff />
          Silencio
        </button>
      ) */ }
    </div>
  </div>
}

export default ResultadoDetailHeader



// WEBPACK FOOTER //
// ./src/components/ResultadoDetailHeader.js